import React, { useState, useEffect } from 'react';
import { PostContext } from './DataContext';
import axios from "axios";

export const PostState = ({ children }) => {
    // Estados iniciales
    const [state, setState] = useState({
        id: null,
        title: '',
        content: '',
        post_slug: '',
        status: 'private',
        button: [],
        langSlugA: '',
        langSlugB: '',
        accordion: [],
        apps: [],
        sessionId: null,
        data: [] 
    });
    
    const [postID, setPostID] = useState(null); // Cambiamos el valor inicial a null
    const [apiURL, setApiURL] = useState('https://apievt.lacnic.net/wp-json/wp/v2/posts');
    const [charging, setCharging] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancel = false;
        
        const fetchPosts = async () => {
            // No hacer la llamada si no hay postID
            if (!postID) {
                return;
            }

            setCharging(true);
            try {
                const responseJSON = await axios.get(`${apiURL}/${postID}`);
                if (!cancel) {
                    const responseData = responseJSON.data;
                    
                    setState(prev => ({
                        ...prev,
                        data: responseData,
                        id: responseData.id,
                        title: responseData.title?.rendered || '',
                        content: responseData.content?.rendered || '',
                        status: responseData.status || 'private',
                        post_slug: responseData.slug || '',
                        accordion: responseData.acf?.create_accordion || [],
                        apps: responseData.acf?.apps || [],
                        button: responseData.acf?.buttons?.[0] || [],
                        sessionId: responseData.agenda_sessions || null,
                        langSlugA: responseData.wpml_translations?.[0]?.slug || '',
                        langSlugB: responseData.wpml_translations?.[1]?.slug || '',
                    }));
                }
            } catch (error) {
                console.error('Error fetching post:', error);
                // Resetear estados en caso de error
                setState(prev => ({
                    ...prev,
                    data: [],
                    error: error.message
                }));
            } finally {
                if (!cancel) {
                    setCharging(false);
                }
            }
        };

        fetchPosts();

        return () => {
            cancel = true;
        };
    }, [postID, apiURL]);
 

    const handleID = (value) => {
        setPostID(value);
    };

    const handleApiURL = (url) => {
        setApiURL(url);
    };

    const handleLoading = (value) => {
        setCharging(value);
    };

    return (
        <PostContext.Provider value={{
            ...state,
            handleID,
            handleApiURL,
            handleLoading,
            charging,
            loading,
            setLoading,
            postID
        }}>
            {children}
        </PostContext.Provider>
    );
};